import * as React from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';

export interface SurveyBackProps {}

/**
 * @name SurveyBack
 * @description A simple component used to navigate our user backwards
 * through one of our surveys.
 */
export const SurveyBack = (_props: SurveyBackProps) => {
  // Hooks
  const { asPath, push, query } = useRouter();
  const { id: _id, question, ...params } = query;

  // Setup
  const value = typeof question === 'string' ? parseInt(question) : 1;
  const base = asPath.split('?')[0];
  const prev = Math.max(1, value - 1);

  // Handlers
  const onClick = () => {
    const urlParams = new URLSearchParams({
      ...params,
      question: prev.toString()
    });
    push(`${base}?${urlParams.toString()}`);
  };

  return (
    <button
      className={classNames(
        'absolute left-2 top-6 z-10 h-10 w-10 transition-opacity delay-200 duration-200 md:top-10',
        {
          'opacity-0': value === 1
        }
      )}
      onClick={onClick}
      title="Go Back"
      type="button"
    >
      <img alt="Go back" src="/images/svg/back.svg" />
    </button>
  );
};
